/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, Icon, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { Box } from 'components/Box'

export function ConsultaSeguimentoIndicatorBlock() {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <VFlow vSpacing={0} style={styles.alignItemsCenter}>
      <div css={styles.line} />
      <Box style={styles.box}>
        <VFlow vSpacing={0} style={styles.alignItemsCenter}>
          <Icon icon='exclamationTriangleFilled' fill='alert' />
          <Text color='alert'>Não para todos</Text>
          <Heading level={4} color='alert'>
            Revise as respostas com o genitor
          </Heading>
          <Text>Pelas orientações do instrumento, não é possível marcar “Não” em todas as perguntas.</Text>
        </VFlow>
      </Box>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  alignItemsCenter: css`
    align-items: center;
  `,
  box: css`
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
  `,
  line: css`
    width: 2px;
    height: 2rem;
    background: ${theme.pallete.status.alert.c50};
  `,
})
